// extracted by mini-css-extract-plugin
export default {"container":"EclipseBackground_container__kZQHj","eclipse":"EclipseBackground_eclipse__67wat","float":"EclipseBackground_float__6vidG"};